import React from "react"
import { Route, Redirect } from "react-router-dom"
import Auth from "./Auth"

class ProtectedRoute extends React.Component {
  state = {
    admin: false,
    loading: true,
  }

  async componentDidMount() {
    const { admin } = await Auth.tokenCheck("teacher")
    if (admin) {
      this.setState({ admin: true })
    }
    this.setState({ loading: false })
  }

  async componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      const response = await Auth.tokenCheck("teacher")
      if (response.authenticated) {
        this.setState({ admin: true })
      }
      else {
        this.setState({ admin: false })
      }
      this.setState({ error: response.error })
      this.setState({ loading: false })
    }
  }

  render() {
    const { loading, admin } = this.state
    if (!loading && !admin) {
      return (
        <Redirect
          to={{
            pathname: "/login",
            // state: {
            //   error: "You are not authorized to access that page.",
            // },
          }}
        />
      )
    } else {
      return (
        !loading && (
          (this.props.component) ?
          <Route
            exact={this.props.exact}
            path={this.props.path}
            component={this.props.component}
          /> :
          <Route
            exact={this.props.exact}
            path={this.props.path}
            render={this.props.render}
          />
        )
      )
    }
  }
}

export default ProtectedRoute
